import {EventUtils} from '@mintdata/mint-kit/api/events/EventUtils';
import {IComponentLogic} from '@mintdata/mint-kit/api/events/logic/IComponentLogic';
import {Compatibility} from '@mintdata/mint-kit/api/models/Compatibility';
import {PropertyUtils} from '@mintdata/mint-kit/api/properties/PropertyUtils';
import {AFrame} from '@mintdata/mint-kit/api/values/frames/AFrame';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import * as React from 'react';

export interface ComponentConfig<T, C>
{
    name:string;
    linkNameToProp?:string;
    tip:string;
    props?:{new():T};
    attachedProps?:{new():C};
    logic?:{new():IComponentLogic<T>};
    isThumbnailMode?:boolean;
    supportsAutofocus?:boolean;
    managesChildLayout?:boolean;
    supportsChildren?:boolean;
    isSvgCompatible?:boolean;
    requireSize?:boolean;
    compatibility?:Compatibility;
    width?:number;
    height?:number;
    exampleFrame?:IFrame;
}

const componentConfigDefaults:Partial<ComponentConfig<any, any>> = {
    isThumbnailMode: false,
    supportsAutofocus: false,
    managesChildLayout: false,
    supportsChildren: false,
    isSvgCompatible: false,
    requireSize: false,
    compatibility: Compatibility.HTML,
    width: 100,
    height: 100,
    exampleFrame: AFrame.empty(),
};

export function Component<T, C = null>(config:ComponentConfig<T, C>):ClassDecorator
{
    const componentConfig = Object.assign({}, componentConfigDefaults, config);

    return function(target:any)
    {
        PropertyUtils.setComponentConfig(target, componentConfig);
        EventUtils.initEvents(target);

        return target;
    };
}


